import { useOrganization } from '@/contexts/OrganizationContext';
import { useRole } from '@/hooks/use-role';

/**
 * Who may see Products > Client prices, and its `Catalogue | Client prices`
 * switch: the shared-locations flag on, `skus.manage` (Admin, Super Admin and
 * the Warehouse Coordinator), and an org that runs a shared location
 * (`is_3pl_provider`). Reads only what is already loaded, so it costs no call.
 *
 * VIEWING only. Every edit control needs `skus.costs_manage`: the view reads
 * `can('skus.costs_manage')` itself and opens read-only for anyone without it
 * (the price writes are gated on that permission in the handler).
 *
 * The ONE check for the view, the switch on the catalogue's bar and the
 * switch on the prices view, so they can never disagree (a pure client that
 * opens `?view=client-prices` gets the quiet line and no switch). The router's
 * RoleGuard sits above it; the handlers' `requirePermission` below it.
 */
export function useClientPricesAccess(): boolean {
  const { organization } = useOrganization();
  const { can } = useRole();
  const sharedLocationsEnabled = (import.meta.env.VITE_SHARED_LOCATIONS_ENABLED ?? '') === 'true';
  return sharedLocationsEnabled && can('skus.manage') && organization?.is_3pl_provider === true;
}
